<nb-card class="bg-transparent">
  <nb-card-header class="pb-0">
    <div class="row">
      <div class="col-lg-4 col-12 text-start">
        <h4 class="fw-semibold ls-1">Room Location List</h4>
      </div>
      <div class="col-lg-8 col-12">
        <div class="d-flex justify-content-end">
          <button (click)="addRoomClicked()" mat-raised-button class="new-compact-btn" color="primary">
            <span class="fa-icon-wrapper"><i class="fas fa-plus me-2"></i></span>
            New Room Location
          </button>
        </div>
      </div>
    </div>
    <nb-card class="mt-4 bg-transparent border-0">
      <nb-card-body class="shadow bg-white grid-wrapper">
        <div class="row">
          <div class="col">
            <kw-filter-dropdown [filterSettings]="this.dropdownSettings"
              [gridCountDataAndMessage]="gridMessageAndCount"
              (filterResultsChange)="setFilterResults($event)">
            </kw-filter-dropdown>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </nb-card-header>
  <nb-card-body class="pt-0">
    <div class="grid-wrapper">
      <div class="mat-elevation-z2 table-scroll" [nbSpinner]="roomLoading">
        <ejs-grid #grid [dataSource]='this.roomLocations' [filterSettings]='this.filterSettings'
          [allowExcelExport]='true' [allowPdfExport]='true' [allowPaging]="true" [pageSettings]="this.pageSettings"
          [allowTextWrap]="true" [allowSelection]='false' [allowSorting]='true' *ngIf="!this.roomLoading">
          <e-columns>
            <!-- <e-column type='checkbox' [allowFiltering]='false' [allowSorting]='false' width='60'></e-column> -->
            <e-column field='name' [filter]='filter' headerText='Name'></e-column>
            <e-column field='description' [filter]='filter' headerText='Description'></e-column>
            <e-column field='barcode' [filter]='filter' headerText='Barcode'></e-column>
            <e-column field='roomName' [valueAccessor]="getRoomName" [filter]='filter'
              headerText='{{"Room" | tenantWords}}'></e-column>
            <e-column field='warehouseName' [valueAccessor]="getWarehouseName" [filter]='filter'
              headerText='{{"Warehouse" | tenantWords}}'></e-column>
            <e-column field='isActive' [filter]='filter' headerText='Active?'>
              <ng-template let-data #template>
                <div *ngIf="data.isActive" style="color: green;">
                  <fa-icon [icon]="faCheck" size="lg"></fa-icon>
                </div>
                <div *ngIf="!data.isActive" style="color: red;">
                  <fa-icon class="success" [icon]="faTimes" size="lg"></fa-icon>
                </div>
              </ng-template>
            </e-column>
            <e-column [filter]='filter' headerText='Edit'>
              <ng-template let-data2 #template>
                <button mat-icon-button (click)="editClicked(data2.id);">
                  <fa-icon size="lg" [icon]="faEdit"></fa-icon>
                </button>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </nb-card-body>
</nb-card>